import { brandingJson } from "./brandingJson";
import { brandingJson2 } from "./brandingJson2";

const currentBrandingJson = brandingJson;

export default currentBrandingJson;
